import React, { useState } from 'react'
import { useConstCallback } from '~hooks'
import { Icon, IconName } from '~components/Icon'
import { Tooltip } from '~components/Tooltip'
import InputBase from './InputBase'
import { InputProps, CustomInputProps } from './TextualFormElement.types'
import * as Styled from './TextualFormElement.styles'

export type ComponentProps = CustomInputProps & Omit<InputProps, 'type'>

const InputPassword: React.FC<ComponentProps> = React.forwardRef<HTMLInputElement, ComponentProps>(({ icon, iconRight, ...inputProps }, ref) => {
  const { size } = inputProps
  const [isShowing, setIsShowing] = useState(false)

  const handleShowButtonClick = useConstCallback(() => setIsShowing(prev => !prev), [])

  const ShowButton = (
    <Tooltip content={isShowing ? 'Hide' : 'Show'} offset={0}>
      <Styled.SideButton onClick={handleShowButtonClick} type="button">
        <Icon name={isShowing ? IconName.eye : IconName.eye_slash} size={size} />
      </Styled.SideButton>
    </Tooltip>
  )

  return (
    <InputBase
      type={isShowing ? 'text' : 'password'}
      prefixElement={icon && <Icon name={icon} size={size} />}
      suffixElement={
        <>
          {ShowButton}
          {iconRight && <Icon name={iconRight} size={size} />}
        </>
      }
      ref={ref}
      {...inputProps}
    />
  )
})

InputPassword.displayName = 'InputPassword'
export default InputPassword
